export enum AnnouncementTypes {
  UPDATE = 'Opdatering',
  CHANGE = 'Rettelse',
  RESULT = 'Resultat',
  CANCELLATION = 'Annullering',
}
